import LoginPage from "./pages/login";
import { useContext } from "react";
import { AuthContext } from "./contexts/auth.context";
import LoadingPage from "./components/generic/LoadingPage";
import { Route, Routes } from "react-router";
import HomePage from "./pages/home";
import { SidebarProvider } from "./contexts/sidebar.context";
import NotFoundPage from "./components/generic/NotFoundPage";
import ProfilePage from "./pages/profile";
import NotePage from "./pages/lists/note/NotePage";

export default function App() {

  const auth = useContext(AuthContext);

  if (!auth.token) return <LoginPage />

  if (!auth.user) return <LoadingPage />

  return (
    <SidebarProvider>
      <Routes>
        <Route index element={<HomePage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/lists/:id" element={<NotePage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </SidebarProvider>
  );
}